import { removeTokenFromLocalStorage } from '@/config/authApi.config';
import { ROUTES } from '@/constaint/route';
import { logoutApi } from '@/services/api/auth';
import { Session } from 'next-auth';
import { signOut, useSession } from 'next-auth/react';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

export const AuthContext = React.createContext<
  { session: Session | undefined; logout: () => Promise<void> } | undefined
>(undefined);

const AUTH_DEFAULT_VALUE = {
  session: undefined,
  user: null,
};

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: session } = useSession();

  const logout = async () => {
    try {
      await logoutApi();
    } catch (error) {
      console.error(error);
    }
    
    // Xóa tất cả localStorage
    removeTokenFromLocalStorage();
    localStorage.clear();
    
    // Xóa tất cả cookie bằng cách đặt thời gian hết hạn về quá khứ
    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Đảm bảo xóa cookie cụ thể
    document.cookie = "next-auth.session-token=;expires=" + new Date().toUTCString() + ";path=/";
    document.cookie = "next-auth.callback-url=;expires=" + new Date().toUTCString() + ";path=/";
    document.cookie = "next-auth.csrf-token=;expires=" + new Date().toUTCString() + ";path=/";
    
    // Đăng xuất từ NextAuth
    await signOut({ redirect: false });
    
    toast.success('Logout successfully');
    
    // Chuyển hướng người dùng sau khi đã xóa hết cookie và localStorage
    window.location.href = ROUTES.AUTH.SIGN_IN;
  };

  return (
    <AuthContext.Provider value={{ session: (session ?? AUTH_DEFAULT_VALUE) as Session, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
